import {Validator} from 'vee-validate';
import {BasicSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Loader from '../../../../shared/components/loader';
import Requests from './../../../services/requests.service';
import CONSTANT from './../../../../shared/constants/constant';
import DatePicker from 'vue2-datepicker';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import Pagination from './../../../../shared/components/pagination'
import moment from 'moment';
import ClientView from '../../../../clientmanagement/views/client/clientlisting/clienteview';
import Util from './../../../../shared/util/util'
import Multiselect from 'vue-multiselect'
export default {
  name: 'pendingRequests',
  components: {
    BasicSelect,
    VueElementLoading,
    DatePicker,
    moment,
    CustomExpandableTable,
    Pagination,
    ClientView,
    Multiselect
  },
  props: ['title'],
  data() {
    return {
      useremail : '',
      tableColumn: ['Company Short/Display Name','Request ID', 'Request For', 'Request By', 'Request Date', 'Action'],
      request : "client",
      requestID : '',
      selectedcompanyName: {
        "value": '',
        "text": ''
      },
      companyName : '',
      CompanyShortNameArr : [],
      innerTableColumn : [],
      clientsystemID : '',
      fromdate : '',
      todate : '',
      currentPage: 1,
      pageCount: 0,
      pageNo: 0,
      totalrows:0,
      offset:0,
      isLoading : false,
      viewFlag : false,
      pendingRequestsList :[],
      generalInfo : {},
      legelInfo : {},
      spocInfo : {},
      bankInfo : {},
      approvalInfo : {},
      statelist : [],
      generalInfoBlank : 1,
      spocInfoBlank : 1,
      legelInfoBlank : 1,
      bankInfoBlak : 1,
      rejectResoncommnet : '',
      userid : '',
      userrole : '',
      checkavaibilty : false,
      rejectSuperApprove : false,
      selectedViewRow : '',
      selectclientSystemID : '',
      selectBusinessAccId: ''
    }
  },
  computed: {},
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.useremail = userdetail.email;
    this.userid = parseInt(userdetail.userid);
    this.userrole = userdetail.rolename[0];
    this.isLoading = true;
    await Promise.all([
      this.getCompanyShortName(),
      this.getList(),
      this.getStateList()
    ]);
    this.isLoading = false;
  },
  methods: {
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    async getStateList() {
      try {
        let result = await Requests.getStateList();
        let tempStateList = result.data.data;
        for (var i = 0; i < tempStateList.length; i++) {
          this.statelist.push({
            'id': tempStateList[i].stateid,
            'label': tempStateList[i].statename.toUpperCase()
          })
        }
      } catch (err) {
        this.statelist = [];
      }
    },
    async getCityList(cityid) {
      try {
        let inputPayload = {
          "stateId": [cityid]
        }
        let result = await Requests.getCityList(inputPayload)
        return result.data.data;
      } catch (err) {
        this.citylist = [];
      }
    },
    selectCompanyName(data){
        this.selectedcompanyName = data;
        this.companyName = data.value;
    },
    async getCompanyShortName(){
      try {
        this.isLoading = true;
        let CompanyShortList = []
        let result = await Requests.getActiveInactiveClientList()
         CompanyShortList = result.data.data;
        for (var i = 0; i < CompanyShortList.length; i++) {
          this.CompanyShortNameArr.push({
            'value': CompanyShortList[i].ClientMasterID,
            'text': CompanyShortList[i].ClientShortName
          })
        }
        this.isLoading = false
      } catch(err){
        this.$alert("Internal Server Error","Pending Requests","error");
      }
    },
    format_date(value){
     if (value) {
        return moment(String(value)).format('DD-MM-YYYY hh:mm')
      }
    },
  async getList(){
      let payload = {
        "offset": this.offset,
        "limit": 10,
        "roleID" : this.userrole,
        "userID" : this.userid
      }
      if (isNaN(this.clientsystemID)) {
        this.$alert("Please Enter Client System ID In Number Format","Client","error");
        return true
      }
      if (isNaN(this.requestID)) {
        this.$alert("Please Enter Request ID In Number Format","Client","error");
        return true
      }
      if (this.clientsystemID) {
        payload.clientID = parseInt(this.clientsystemID);
      }
      if (this.requestID) {
        payload.requestID = this.requestID;
      }
      if (this.companyName) {
        payload.clientID = parseInt(this.companyName.value);
      }
      if (this.fromdate) {
        payload.fromDate = moment(this.fromdate).format('YYYY-MM-DD');
        if (this.fromdate > this.todate) {
          this.$alert("From Date Must be Less Than To Date","Pending Requests","error");
          return true;
        }
      }

      if (this.todate) {
        payload.toDate = moment(this.todate).format('YYYY-MM-DD');
        if (this.fromdate > this.todate) {
          this.$alert("From Date Must be Less Than To Date","Pending Requests","error");
          return true;
        }
      }

      payload.objectType = this.request;

      this.isLoading = true;
      let result = await Requests.getAllPendingApproveRequest(payload);
      this.isLoading = false;

      if (result.data.code == 200) {
        let data = result.data.data.rows;
        this.pendingRequestsList = [];
        for (var i = 0; i < data.length; i++) {
          this.pendingRequestsList.push({
            'Company Short/Display Name' : (data[i].clientshortname != undefined) ? data[i].clientshortname : data[i].objectname,
            'Request ID': data[i].id,
            'Request For': `${data[i].objecttype} Approval`,
            'Request By':  data[i].createdby,
            'Request Date': Util.displayDateTimeFormat(data[i].createddate),
            'id' : (data[i].clientid != null) ? data[i].clientid : data[i].objectrecordid,
            'clientShortName' : data[i].clientshortname,
            'objectShortName' : data[i].objectname,
          })
        }
        this.totalrows = result.data.data.count
        if (this.totalrows < 10) {
          this.pageCount = 1
        } else {
          this.pageCount = Math.ceil(this.totalrows / 10);
        }
      }else {
        this.isLoading = false;
        this.$alert("Internal Server Error","Pending Requests","error");
      }
    },
  async onSubmitSearch(){
    if (this.request == '' && this.requestID == '' &&
       this.companyName == '' && this.clientsystemID == '' &&
       this.fromdate == '' && this.todate == '') {
        this.$alert("Please Select At List One Filed","Pending Requests","error");
      }else {
        this.currentPage = 1;
        this.offset = 0;
        this.totalrows = 0;
        this.getList();
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) * 10
      this.getList();
    },
    async getCustomTableEvent(event) {
      if (event.actionType == "approve") {
          if (this.request == "client") {
            let shortName = '';
            for (var i = 0; i < this.pendingRequestsList.length; i++) {
              if (this.pendingRequestsList[i].id == event.id) {
                shortName = this.pendingRequestsList[i].clientShortName
              }
            }
            this.approvalInfo = {};
            this.approvalInfo.ClientShortName = shortName;
            this.approvalInfo.ClientSystemID = event.id;
            this.approve();
          }
          if (this.request == "contract") {
            let shortName = '';
            for (var i = 0; i < this.pendingRequestsList.length; i++) {
              if (this.pendingRequestsList[i].id == event.id) {
                shortName = this.pendingRequestsList[i].objectShortName
              }
            }
            this.approvalInfo.objectShortName = shortName;
            this.approvalInfo.id = event.id;
            this.approveRequestForContractAndRate();
          }
          if (this.request == "rate") {
            let shortName = '';
            for (var i = 0; i < this.pendingRequestsList.length; i++) {

              if (this.pendingRequestsList[i].id == event.id) {
                shortName = this.pendingRequestsList[i].objectShortName
              }
            }
            this.approvalInfo.objectShortName = shortName;
            this.approvalInfo.id = event.id;

            this.approveRequestForContractAndRate();
          }
        }
        if (event.actionType == "reject") {
          if (this.request == "client") {
            let shortName = '';
            for (var i = 0; i < this.pendingRequestsList.length; i++) {

              if (this.pendingRequestsList[i].id == event.id) {
                shortName = this.pendingRequestsList[i].clientShortName
              }
            }

            this.approvalInfo = {};
            this.approvalInfo.ClientShortName = shortName;
            this.approvalInfo.ClientSystemID = event.id;
            this.reject();
          }
          if (this.request == "contract") {
            let shortName = '';
            for (var i = 0; i < this.pendingRequestsList.length; i++) {

              if (this.pendingRequestsList[i].id == event.id) {
                shortName = this.pendingRequestsList[i].objectShortName
              }
            }
            this.approvalInfo.objectShortName = shortName;
            this.approvalInfo.id = event.id;
            this.rejectRequestForContractAndRate();
          }
          if (this.request == "rate") {
            let shortName = '';
            for (var i = 0; i < this.pendingRequestsList.length; i++) {

              if (this.pendingRequestsList[i].id == event.id) {
                shortName = this.pendingRequestsList[i].objectShortName
              }
            }
            this.approvalInfo.objectShortName = shortName;
            this.approvalInfo.id = event.id;
            this.rejectRequestForContractAndRate();
          }
        }
        if (event.actionType == "view")  {
          if (this.request == "client") {
            this.viewFlag = true;
            let shortName = '';
            for (var i = 0; i < this.pendingRequestsList.length; i++) {
              if (this.pendingRequestsList[i].id == event.id) {
                shortName = this.pendingRequestsList[i].clientShortName
              }
            }
            this.approvalInfo = {};
            this.approvalInfo.ClientShortName = shortName;
            this.approvalInfo.ClientSystemID = event.id;
            let payload = {
              clientid : event.id
            }
            this.selectBusinessAccId = event.id;
            this.selectedViewRow = payload;
            this.viewFlag = false;
          }
          if (this.request == "contract") {
          }
          if (this.request == "rate") {
          }
        }
      },
      fileview(index){
        var link = document.createElement('a');
        link.href = index;
        link.setAttribute('target','_blank');
        window.open(index, '_blank');
        link.remove();
        return true;
      },
      approveRequestForContractAndRate(){
        this.$confirm(`Do you want to approve`,'Approve Request','question').then(async (result) => {
          if (result) {
            this.viewFlag = true;
            let inputRow = {
              'objectType' : this.request,
              'objectrecordIDName' : this.approvalInfo.objectShortName,
              'objectrecordID' : this.approvalInfo.id,
              'createdby' : this.useremail,
              'roleID' : this.userrole,
              'userID' : this.userid,
              'projectkey' : 'cargoautoallocation'
            }
            let resultofAvaibilty = await Requests.approveRequestForContractAndRate(inputRow);
            this.viewFlag = false;
            //let approvalResult =  await MasterService.sendForApproveInKYC(payload)
            let getClientInfo = await this.innerTableColumn.filter(obj => obj.id === this.approvalInfo.id).map(filteredObj => filteredObj);
            this.$alert(`Request approved successfully`,"Approve Request","success");
            this.$refs.custometablecomponent.ShowEachDetails(getClientInfo,this.approvalInfo.id);
            this.clearForm();
          }
        }).catch(e =>{
          this.viewFlag = false;
          this.$alert('Approve Request Cancel',"Approve Request","error");
        });
      },
      async rejectRequestForContractAndRate(){
        let rejectResons = {'Other': 'Other'}
        if (this.request == 'contract') {

          rejectResons["Contract Details Not Correct"]= 'Contract Details Not Correct';
          rejectResons["Need to verify Contract"]= 'Need to verify Contract';
        }else {
          rejectResons["Rate Details Not Correct"]= 'Rate Details Not Correct';
          rejectResons["Need to verify Rate"] = 'Need to verify Rate';
        }
        this.$fire({
          title: 'Reject Request',
          input: 'select',
          inputOptions: rejectResons,
          confirmButtonText:'<i class="fa fa-thumbs-down"></i> Reject',
          inputPlaceholder: 'Select Reject Reson',
          showCancelButton: true,
          inputValidator: (value) => {

          return new Promise(async (resolve) => {
            if (value == '') {
              this.$alert(`Please select at least one reject reason`,"Approve Request","error");
              return true;
            }
              if (value == 'Other') {
                const { value: valueforComment } = await this.$fire({
                title: 'Add Comment',
                input: 'textarea',
                inputPlaceholder: 'Type Your Comment',
                inputAttributes: {
                  'aria-label': 'Type Your Comment'
                },
                showCancelButton: true
              })
              this.rejectResoncommnet = valueforComment;
              if (valueforComment == undefined) {
                resolve()
              }else {

                let inputRow = {
                  'objectType' : this.request,
                  'objectrecordIDName' : this.approvalInfo.objectShortName,
                  'objectrecordID' : this.approvalInfo.id,
                  'createdby' : this.useremail,
                  'roleID' : this.userrole,
                  'userID' : this.userid,
                  'projectkey' : 'cargoautoallocation'
                }
                if (value == 'Other') {
                  if (this.rejectResoncommnet == '') {
                    this.$alert(`Please enter reject comment `,"Approve Request","error");
                    return true;
                  }
                  inputRow.rejectcommnet = this.rejectResoncommnet;
                }else {
                  inputRow.rejectcommnet = value;
                }
                this.viewFlag = true;
                let getClientInfo = await this.innerTableColumn.filter(obj => obj.id === this.approvalInfo.id).map(filteredObj => filteredObj);
                let resultofAvaibilty = await Requests.rejectRequestForContractAndRate(inputRow);
                this.$refs.custometablecomponent.ShowEachDetails(getClientInfo,this.approvalInfo.id);
                this.viewFlag = false;
                await this.$alert(`Request rejected successfully`,"Approve Request","success");
                this.clearForm();
                resolve()
              }
          } else {
            this.rejectResoncommnet = value;
            this.viewFlag = true;

            let inputRow = {
              'objectType' : this.request,
              'clientID' : this.approvalInfo.ClientSystemID,
              'roleID' : this.userrole,
              'userID' : this.userid,
              'createdby' : this.useremail,
              'clientShortName' : this.approvalInfo.ClientShortName,
              'rejectcommnet' :  this.rejectResoncommnet
            }
            let getClientInfo = await this.innerTableColumn.filter(obj => obj.id === this.approvalInfo.id).map(filteredObj => filteredObj);
            let resultofAvaibilty = await Requests.rejectRequestForContractAndRate(inputRow);
            this.$refs.custometablecomponent.ShowEachDetails(getClientInfo,this.approvalInfo.id);
            this.viewFlag = false;
            this.clearForm();
            await this.$alert(`Request rejected successfully`,"Approve Request","success");
            resolve()
          }
        })

    }
  })
      },
      approve(){
        this.$confirm(`Do you want to approve`,'Approve Request','question').then(async (result) => {
          if (result) {
            this.viewFlag = true;

            let inputRow = {
              'objectType' : this.request,
              'clientID' : this.approvalInfo.ClientSystemID,
              'roleID' : this.userrole,
              'userID' : this.userid,
              'createdby' : this.useremail,
              'clientShortName' : this.approvalInfo.ClientShortName
            }
            let resultofAvaibilty = await Requests.approveRequest(inputRow);
            this.viewFlag = false;
            //let approvalResult =  await MasterService.sendForApproveInKYC(payload)
            let getClientInfo = await this.innerTableColumn.filter(obj => obj.ClientShortName === this.approvalInfo.ClientSystemID).map(filteredObj => filteredObj);
            this.$alert(`Request approved successfully`,"Approve Request","success");
            this.$refs.custometablecomponent.ShowEachDetails(getClientInfo,this.approvalInfo.ClientSystemID);
            this.clearForm();
          }
        }).catch(e =>{
          this.viewFlag = false;
          this.$alert('Client Approve Request Cancel',"Approve Request","error");
        });
      },
    async reject(){
      this.$fire({
        title: 'Reject Request',
        input: 'select',
        inputOptions: {
          'Client Details Not Correct': 'Client Details Not Correct',
          'Need to verify Client': 'Need to verify Client',
          'Need to verify Client': 'Client contract is no long with Xbees',
          'Other': 'Other',
        },
        confirmButtonText:'<i class="fa fa-thumbs-down"></i> Reject',
        inputPlaceholder: 'Select Reject Reson',
        showCancelButton: true,
        inputValidator: (value) => {

        return new Promise(async (resolve) => {
          if (value == '') {
            this.$alert(`Please select at least one reject reason`,"Approve Request","error");
            return true;
          }
            if (value == 'Other') {
              const { value: valueforComment } = await this.$fire({
              title: 'Add Comment',
              input: 'textarea',
              inputPlaceholder: 'Type Your Comment',
              inputAttributes: {
                'aria-label': 'Type Your Comment'
              },
              showCancelButton: true
            })
            this.rejectResoncommnet = valueforComment;
            if (valueforComment == undefined) {
              resolve()
            }else {

              let inputRow = {
                'objectType' : this.request,
                'clientID' : this.approvalInfo.ClientSystemID,
                'roleID' : this.userrole,
                'userID' : this.userid,
                'createdby' : this.useremail,
                'clientShortName' : this.approvalInfo.ClientShortName,
                'rejectSuperApprove' : this.rejectSuperApprove
              }
              if (value == 'Other') {
                if (this.rejectResoncommnet == '') {
                  this.$alert(`Please enter reject comment `,"Approve Request","error");
                  return true;
                }
                inputRow.rejectcommnet = this.rejectResoncommnet;
              }else {
                inputRow.rejectcommnet = value;
              }
              this.viewFlag = true;
              let getClientInfo = await this.innerTableColumn.filter(obj => obj.ClientShortName === this.approvalInfo.ClientSystemID).map(filteredObj => filteredObj);
              let resultofAvaibilty = await Requests.rejectrequest(inputRow);
              this.$refs.custometablecomponent.ShowEachDetails(getClientInfo,this.approvalInfo.ClientSystemID);
              this.viewFlag = false;
              await this.$alert(`Request rejected successfully`,"Approve Request","success");
              this.clearForm();
              resolve()
            }
        } else {
          this.rejectResoncommnet = value;
          this.viewFlag = true;

          let inputRow = {
            'objectType' : this.request,
            'clientID' : this.approvalInfo.ClientSystemID,
            'roleID' : this.userrole,
            'userID' : this.userid,
            'createdby' : this.useremail,
            'clientShortName' : this.approvalInfo.ClientShortName,
            'rejectcommnet' :  this.rejectResoncommnet,
            'rejectSuperApprove' : this.rejectSuperApprove
          }
          let getClientInfo = await this.innerTableColumn.filter(obj => obj.ClientShortName === this.approvalInfo.ClientSystemID).map(filteredObj => filteredObj);
          let resultofAvaibilty = await Requests.rejectrequest(inputRow);
          this.$refs.custometablecomponent.ShowEachDetails(getClientInfo,this.approvalInfo.ClientSystemID);
          this.viewFlag = false;
          this.clearForm();
          await this.$alert(`Request rejected successfully`,"Approve Request","success");
          resolve()
        }
      })

  }
})

  },
  clearForm(){
    this.requestID = '';
    this.companyName = '';
    this.clientsystemID = '';
    this.fromdate = '';
    this.pendingRequestsList = [];
    this.todate = '';
    this.currentPage = 1;
    this.totalrows = 0;
    this.offset = 0;
    this.selectedcompanyName = {
      "value": '',
      "text": ''
    };
    this.getList();
  }
  }
}



// WEBPACK FOOTER //
// ./src/modules/requests/views/approvalrequest/pendingrequests/pendingrequests.component.js